import * as Yup from 'yup';

export const protocolSchema = Yup.object().shape({
    category: Yup.string(),
    categoryOther: Yup.string(),
    note: Yup.string(),
});
